import React from "react";
import { LineChart, Line, ResponsiveContainer } from "recharts";
import { CaretUp, CaretDown } from "@phosphor-icons/react";

export default function KpiCard({
    label, value, change, spark = [], Icon, accent = "#15803D",
    format = (v) => v, testId,
}) {
    const isUp = (change ?? 0) >= 0;
    const changeColor = isUp ? "#15803D" : "#DC2626";
    return (
        <div
            className="kpi-card bg-white border border-neutral-200 rounded-md p-4 flex flex-col gap-3 h-full fade-up"
            data-testid={testId}
        >
            <div className="flex items-start justify-between gap-2">
                <div className="eyebrow leading-tight">{label}</div>
                {Icon && (
                    <div className="w-8 h-8 rounded flex items-center justify-center shrink-0"
                         style={{ backgroundColor: accent + "14", color: accent }}>
                        <Icon size={16} weight="bold" />
                    </div>
                )}
            </div>
            <div className="flex items-end justify-between gap-2">
                <div className="text-2xl font-extrabold tracking-tight font-display tabular" style={{ color: "#0A0A0A" }}>
                    {format(value)}
                </div>
                {change !== undefined && change !== null && (
                    <div className="flex items-center gap-0.5 text-xs font-semibold" style={{ color: changeColor }}>
                        {isUp ? <CaretUp size={12} weight="bold" /> : <CaretDown size={12} weight="bold" />}
                        {Math.abs(change)}%
                    </div>
                )}
            </div>
            {spark && spark.length > 1 && (
                <div className="h-8 -mx-1">
                    <ResponsiveContainer width="100%" height="100%">
                        <LineChart data={spark.map((v, i) => ({ i, v }))}>
                            <Line type="monotone" dataKey="v" stroke={accent} strokeWidth={2} dot={false} isAnimationActive={false} />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            )}
        </div>
    );
}
